import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import * as API from '@src/service/kol'
import * as TS from '@src/types/kol'

const initialState: {
  allCategoryKols: { predictCategory: TS.KolCategory[]; userCustomizeCategory: TS.KolCategory[] }
} = {
  allCategoryKols: {
    predictCategory: [],
    userCustomizeCategory: [],
  },
}

const account = createSlice({
  name: 'kol',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getAllCategorys.fulfilled, (state, action) => {
      state.allCategoryKols = action.payload
    })
  },
})

export const addUserCustomizeCategoryUser = createAsyncThunk(
  'kol/addUserCustomizeCategoryUser',
  async (categoryKols: TS.AddCustomKol) => {
    const res = await API.addUserCustomizeCategoryUser(categoryKols)
    return res
  },
)

export const addUserCustomizeCategory = createAsyncThunk(
  'kol/addUserCustomizeCategory',
  async (categoryName: string) => {
    const res = await API.addUserCustomizeCategory(categoryName)
    return res
  },
)

export const getAllCategorys = createAsyncThunk('kol/getAllCategorys', async (agentId: number) => {
  const { data } = await API.getAllCategorys(agentId)
  return data
})

export const deleteUserCustomizeCategory = createAsyncThunk(
  'kol/deleteUserCustomizeCategory',
  async (id: number) => {
    const res = await API.deleteUserCustomizeCategory(id)
    return res
  },
)

export const deleteUserCustomizeCategoryUser = createAsyncThunk(
  'kol/deleteUserCustomizeCategoryUser',
  async (id: number) => {
    const res = await API.deleteUserCustomizeCategoryUser(id)
    return res
  },
)

export const editUserCustomizeCategory = createAsyncThunk(
  'kol/editUserCustomizeCategory',
  async ({ id, categoryName }: { id: number; categoryName: string }) => {
    const res = await API.editUserCustomizeCategory(id, categoryName)
    return res
  },
)

export const delBatchKol = createAsyncThunk(
  'agent/delBatchKol',
  async (data: { agentId: number; ids: number[] }) => {
    const { code } = await API.deleteBatchKol(data)
    if (code === 0) {
      return code
    }
    return code
  },
)
export default account.reducer
